import React from 'react';
import PageWrapper from '../layout/PageWrapper';
import { Users } from 'lucide-react';
import ProprietaireList from '../components/ProprietaireList';
import { MdOutlinePeopleAlt } from "react-icons/md";

/**
 * Harmonisation propriétaires:
 * - Header unique
 * - Largeur max identique
 * - Overflow horizontal
 * - Masque H1 interne si existant
 */
export default function ProprietairesPage() {
  return (
    <PageWrapper icon={MdOutlinePeopleAlt} title="Propriétaires" maxWidth="max-w-full">
      <style>{`.page-content > h1:first-of-type{display:none}`}</style>
      <div className="page-content mx-auto max-w-7xl">
        <div className="overflow-x-auto">
          <ProprietaireList />
        </div>
      </div>
    </PageWrapper>
  );
}
